export const faqs = [
  {
    q: 'How will I receive the materials?',
    a: 'Immediately after your purchase, you’ll receive instructions to access the digital materials. The six volumes and five bonuses are provided in downloadable digital formats.',
  },
  {
    q: 'Is this a course?',
    a: 'No. The Praxis & Motor Planning Clinical Pathway™ is a self-paced educational resource consisting of digital volumes, visual reference materials, printable worksheets, and fictional case exercises. You can review the materials at your own pace and return to the tools whenever you need them.',
  },
  {
    q: 'Who is this product for?',
    a: 'It’s designed primarily for Pediatric Occupational Therapists and Occupational Therapy students who want a more structured educational framework for organizing observations related to praxis, motor planning, and functional participation.',
  },
  {
    q: 'Do I need previous experience with praxis or motor planning?',
    a: 'A basic familiarity with pediatric occupational therapy is helpful, but the materials are organized to make the concepts easier to review and apply in educational exercises. The pathway is not a substitute for foundational education, supervised clinical training, or advanced professional instruction.',
  },
  {
    q: 'Does this product diagnose praxis or motor planning difficulties?',
    a: 'No. This is an educational resource designed to support observation, information organization, and clinical reasoning. It does not diagnose developmental conditions, establish clinical classifications, or determine the underlying cause of an individual child’s motor difficulties.',
  },
  {
    q: 'Does it replace standardized assessments or professional training?',
    a: 'No. The pathway does not replace standardized assessments, comprehensive evaluation, professional judgment, supervised training, or appropriate multidisciplinary care. Its purpose is to help you organize information and identify questions that may warrant further investigation.',
  },
  {
    q: 'Can I print the materials?',
    a: 'Yes. The worksheets and printable resources are designed to be used digitally or printed for personal professional learning and case organization, subject to the applicable usage terms.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. The introductory price is USD $27, paid once. There is no monthly subscription. Your currency is converted automatically at checkout.',
  },
  {
    q: 'How long will I have access?',
    a: 'You’ll receive lifetime access to the purchased digital materials, subject to the applicable platform and purchase terms.',
  },
  {
    q: 'What if I change my mind?',
    a: 'Your purchase includes a 7-day guarantee, subject to the applicable purchase terms. If you decide the materials aren’t right for you within that period, you can request a refund according to those terms.',
  },
];
